import { useState } from 'react'
import classnames from 'classnames'
import Select from '@components/Select'
import Button from '@components/Button'
import { paymentNoticeRegionsSelector } from 'wordpress/selectors'

import styles from './styles.module.scss'

const PayViolation = ({ regions, translate: t }) => {
    const [showRegionCities, setShowRegionCities] = useState(null)

    const handleRegionOnClick = region => {
        if (region.cities) {
            setShowRegionCities(region.regionTitle)
        } else {
            window.open(region.regionNoticeUrl, '_blank')
        }
    }

    const handleCityOnChange = (city, reg) => {
        window.open(city.cityNoticeUrl || reg.regionNoticeUrl, '_blank')
    }

    return (
        <>
            <div className={styles.topImage} />
            <div className={styles.content}>
                <h1>
                    <T>pay.violation.title</T>
                </h1>
                <p className="my-4">
                    <T>pay.violation.text</T>
                </p>
                <div className={classnames('d-sm-flex', 'flex-wrap', styles.regions)}>
                    {regions &&
                        regions.map((column, i) => (
                            <div key={i} className="col-sm-6 col-xl-4">
                                {column.map((reg, i) => (
                                    <div key={i} className="mt-3">
                                        <Button
                                            btnStyle={showRegionCities === reg.id ? 'primary' : 'outline'}
                                            block
                                            className={classnames({ ['mb-2']: showRegionCities === reg.regionTitle })}
                                            onClick={() => handleRegionOnClick(reg)}>
                                            {reg.regionTitle}
                                        </Button>
                                        {showRegionCities === reg.regionTitle && (
                                            <Select
                                                options={reg.cities}
                                                defaultValue={t('pay.violation.select.city')}
                                                onChange={c => handleCityOnChange(c, reg)}
                                                className="mt-2"
                                                getOptionLabel={opt => opt.cityTitle}
                                            />
                                        )}
                                    </div>
                                ))}
                            </div>
                        ))}
                </div>
            </div>
        </>
    )
}

export default compose(
    withTranslate,
    connect(
        createStructuredSelector({
            regions: paymentNoticeRegionsSelector,
        })
    )
)(PayViolation)
